import React, { useContext } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../componentsInternal/WithTitle';
import { Helmet } from '../components/meta';
const Error404Page = () => {
    const { t } = useTranslation();
    usePageClassName('error-page');
    const { pages } = useContext(ConfigContext);
    const title = t('pageTitles.error404');
    const Page = pages.error404.component;
    return (React.createElement(WithTitle, { title: title },
        React.createElement(Helmet, null,
            React.createElement("meta", { name: "robots", content: "noindex" })),
        React.createElement(Page, null)));
};
Error404Page.displayName = 'Error404Page';
export default Error404Page;
//# sourceMappingURL=error404.js.map